<template>
  <div class="progress" :title="title">
    <span class="bar" aria-hidden="true"><i :style="{width: percent + '%'}"></i></span>
    <span class="figures">{{ done }}/{{ total }}</span>
  </div>
</template>

<script>
/**
 * Avancement d'un sujet : étapes faites sur étapes qui s'appliquent (texte rédigé, texte terminé, image, publication, vérifications).
 * Calculé par le service, jamais saisi.
 */
export default {
  name: 'TopicProgress',
  props: {
    progress: {type: Object, default: undefined},
  },
  computed: {
    done() {
      return this.progress ? this.progress.done : 0;
    },
    total() {
      return this.progress ? this.progress.total : 0;
    },
    percent() {
      return this.progress ? this.progress.percent : 0;
    },
    title() {
      return this.total === 0 ? "Aucune étape pour l'instant" : `${this.done} étape${this.done > 1 ? 's' : ''} faite${this.done > 1 ? 's' : ''} sur ${this.total} (${this.percent} %)`;
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.progress
  display flex
  align-items center
  gap 8px
  min-width 0

.bar
  flex 1 1 60px
  min-width 40px
  max-width 120px
  height 8px
  overflow hidden
  border-radius 8px
  border 1px solid CTRL_BORDER
  background white

  i
    display block
    height 100%
    border-radius 8px
    background THEME_COLOR_PRIMARY

.figures
  flex none
  font-size 0.85em
  font-weight 600
  font-variant-numeric tabular-nums
  color CTRL_TEXT_MUTED
</style>
